export default {
  already_have_account: 'Sudah punya akun?',
  create_account: 'Buat Akun',
  email_address: 'Alamat email',
  dont_have_account: 'Belum punya akun?',
  forgot_password: 'Lupa Kata Sandi',
  forgot_your_password: 'Lupa Kata Sandi Anda?',
  forgot_instruction: 'Masukkan alamat email Anda dan kami akan mengirimkan tautan untuk mengatur ulang kata sandi Anda.',
  login_to_pilihlaptop: 'Masuk ke PilihLaptop',
  register: 'Daftar',
  register_pilihlaptop: 'Daftar di PilihLaptop',
  reset: 'Atur Ulang',
  reset_password: 'Atur Ulang Kata Sandi',
  reset_success: 'Kami baru saja mengirimi Anda tautan untuk menyetel ulang sandi Anda. Link ini berlaku selama 24 jam. Setelah itu, Anda dapat menerima tautan baru kapan saja dengan meminta ulang kata sandi.',
};
